export const Home = {
    home: 'خانه',

    shops: 'فروشگاه‌ها',
    goodsList: 'لیست محصولات',
    orders: 'سفارشات',
    login: 'ورود',
    searchPlaceHolder: 'جستجوی محصول یا برند',
    favs: 'جذابها',
    aboutUs: 'ما را بشناسید',
    shopsSearchPlaceHolder: 'فروشگاه مورد نظر خود را جستجو کنید',
    copyRight: 'کلیه حقوق این وبسایت متعلق به لوکسین لوکس می‌باشد',
    NotFoundShop: 'فروشگاهی با این اسم یافت نشد',
    NotFoundGoods: 'محصولی در این دسته بندی نیست',
    From: 'از',
    To: 'تا',
}
